"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.accountGrade.list': 'Pacchetti Prezzo',
    'route.accountGrade.create': 'Crea Pacchetto Prezzo',
    'route.accountGrade.edit': 'Modifica Pacchetto Prezzo',
    'route.accountGrade.preview': 'Anteprima Pacchetto Prezzo',
};
